'use client';

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useDateRange } from '@/contexts/date-range-context';
import { format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';

export function DatePicker() {
  const { dateRange, setDateRange } = useDateRange();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-empty={!dateRange}
          className="w-fit justify-start text-left font-normal data-[empty=true]:text-muted-foreground"
        >
          <CalendarIcon />
          {dateRange?.from && dateRange?.to ? (
            `${format(dateRange.from, 'PPP')} - ${format(dateRange.to, 'PPP')}`
          ) : (
            <span>Pick a period</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="range"
          defaultMonth={dateRange?.from}
          numberOfMonths={2}
          selected={dateRange ? { from: dateRange.from, to: dateRange.to } : undefined}
          onSelect={(date) => setDateRange(date ? { from: date.from, to: date.to } : undefined)}
          className="rounded-lg border shadow-sm"
        />
      </PopoverContent>
    </Popover>
  );
}
